import IntegrationMessagesListPage from '../shared/IntegrationMessagesListPage';

const InternalOutboxMessagesListPage = () => (
    <IntegrationMessagesListPage kind="internalOutbox" />
);

export default InternalOutboxMessagesListPage;
